import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, Empty, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import LocalizedText from '../components/LocalizedText';

export default function HeaderNotifications({
  items = [],
  messages = [],
  loading = false,
  onMarkAllRead,
  markAllLoading = false,
}) {
  const { t } = useTranslation();
  const kpiItems = Array.isArray(items) ? items.filter((item) => Number(item.count ?? 0) > 0) : [];
  const personal = Array.isArray(messages) ? messages : [];
  const unreadPersonal = personal.filter((item) => !item.read).length;
  const unread = unreadPersonal + kpiItems.reduce((sum, item) => sum + Number(item.count || 0), 0);
  const empty = personal.length === 0 && kpiItems.length === 0;

  const content = (
    <div className="header-notifications">
      <div className="header-notifications__title-row">
        <div className="header-notifications__title">{t('common.notifications')}</div>
        {personal.length > 0 && onMarkAllRead ? (
          <Button type="link" size="small" loading={markAllLoading} onClick={onMarkAllRead}>
            {t('common.markAllRead')}
          </Button>
        ) : null}
      </div>
      {loading ? (
        <div className="header-notifications__empty">{t('common.loading')}</div>
      ) : empty ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('common.noNotifications')} />
      ) : (
        <>
          {personal.length > 0 && (
            <ul className="header-notifications__list">
              {personal.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className={`header-notifications__message${item.read ? '' : ' header-notifications__message--unread'}`}
                    onClick={item.onClick}
                  >
                    <span className="header-notifications__message-title">
                      {typeof item.title === 'object'
                        ? <LocalizedText value={item.title} />
                        : item.title}
                    </span>
                    {item.body ? (
                      <span className="header-notifications__message-body">
                        {typeof item.body === 'object'
                          ? <LocalizedText value={item.body} />
                          : item.body}
                      </span>
                    ) : null}
                  </button>
                </li>
              ))}
            </ul>
          )}
          {kpiItems.length > 0 && (
            <ul className="header-notifications__list header-notifications__list--kpi">
              {kpiItems.map((item) => (
                <li key={item.key}>
                  <button type="button" className="header-notifications__item" onClick={item.onClick}>
                    <span>
                      {typeof item.title === 'object'
                        ? <LocalizedText value={item.title} />
                        : item.title}
                    </span>
                    <b dir="ltr">{item.count}</b>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomRight" overlayClassName="header-notifications-popover">
      <Badge count={unread > 99 ? '99+' : unread} size="small" offset={[-2, 2]}>
        <Button
          type="text"
          className="app-header__notifications"
          icon={<BellOutlined />}
          aria-label={t('common.notifications')}
        />
      </Badge>
    </Popover>
  );
}
